module.exports = __webpack_public_path__ + "img/warning-icon.3b2b368a.svg";